// extracted by mini-css-extract-plugin
module.exports = {"goBack":"goback_goBack__2Z0xL"};